import { TableFilterType } from 'features/TableFilter';
import { getFilterServerFormatDate } from 'shared/utils/helpers/getDateFormat';

interface PriceRaiseListFilters {
  warehouseId?: string | string[];
  priceRaiseDateFrom?: string;
  priceRaiseDateTo?: string;
  nextReviewDateFrom?: string;
  nextReviewDateTo?: string;
  notificationSentAtFrom?: string;
  notificationSentAtTo?: string;
  status?: string;
}

export const transformPriceRaiseListFilters = ({
  selectedWarehouses,
  priceRaiseDateFrom,
  priceRaiseDateTo,
  nextReviewDateFrom,
  nextReviewDateTo,
  notificationSentAtFrom,
  notificationSentAtTo,
  status,
}: TableFilterType): PriceRaiseListFilters => {
  return {
    warehouseId: selectedWarehouses?.value?.length ? selectedWarehouses.value : undefined,
    priceRaiseDateFrom: getFilterServerFormatDate(priceRaiseDateFrom?.value),
    priceRaiseDateTo: getFilterServerFormatDate(priceRaiseDateTo?.value),
    nextReviewDateFrom: getFilterServerFormatDate(nextReviewDateFrom?.value),
    nextReviewDateTo: getFilterServerFormatDate(nextReviewDateTo?.value),
    notificationSentAtFrom: getFilterServerFormatDate(notificationSentAtFrom?.value),
    notificationSentAtTo: getFilterServerFormatDate(notificationSentAtTo?.value),
    status: status?.value || undefined,
  };
};
